import _Student from './component';
import _routes from './routes';
import _accessors from './accessors';
import _actions from './actions';
import _reducer from './reducer';

export const Student = _Student;
export const routes = _routes;
export const accessors = _accessors;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./containers/Student/index.js